import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Overlay, usePopover } from "@gemini/core";
import { Button, Tabs } from "@gemini/ui";
import { CloseIcon, GearFilledIcon } from "@gemini/icons";
import { useEffect, useMemo, useRef, useState } from "react";
import { RouterTabPanel } from "./panels/RouterTabPanel";
import { ApplicationTabPanel } from "./panels/ApplicationTabPanel";
import { DebugTabPanel } from "./panels/DebugTabPanel";
export const DevTools = () => (_jsx(Overlay, { isOpen: true, children: _jsx(DevToolsContent, {}) }));
const DevToolsContent = () => {
    const [currentTab, setCurrentTab] = useState(RouterTabPanel.id);
    const triggerRef = useRef(null);
    const popoverRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const tabsItems = useMemo(() => {
        return [
            {
                id: RouterTabPanel.id,
                label: RouterTabPanel.label,
                content: (_jsx(RouterTabPanel.Component, { isActive: isOpen && currentTab === RouterTabPanel.id })),
            },
            {
                id: ApplicationTabPanel.id,
                label: ApplicationTabPanel.label,
                content: (_jsx(ApplicationTabPanel.Component, { isActive: isOpen && currentTab === ApplicationTabPanel.id })),
            },
            {
                id: DebugTabPanel.id,
                label: DebugTabPanel.label,
                content: _jsx(DebugTabPanel.Component, {}),
            },
        ];
    }, [currentTab, isOpen]);
    const { boxProps } = usePopover({ trigger: triggerRef, popover: popoverRef }, {
        close() {
            // No-op to require an explicit action to close the dev tools to prevent auto-closing behavior.
            // Why? Prevent developer frustration especially when the scroll target is delegated from the dev tools to the body
            // (it can occur automatically when an inner scrollable popover container reaches its last item)
        },
        isOpen,
        offset: 20,
        placement: "top",
        unsafe_isNonModal: true,
    });
    // Closing behavior
    useEffect(() => {
        if (!isOpen)
            return;
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        const handleClickOutside = (event) => {
            if (popoverRef.current &&
                !popoverRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown, true);
        document.addEventListener("pointerdown", handleClickOutside);
        return () => {
            document.removeEventListener("keydown", handleKeyDown, true);
            document.removeEventListener("pointerdown", handleClickOutside);
        };
    }, [isOpen]);
    return (_jsxs(Box, { position: "fixed", bottom: "spacing.8", right: "spacing.8", zIndex: "zIndex.2", children: [_jsx(Box, { ...boxProps.popover, ref: popoverRef, boxShadow: "shadow.8", borderRadius: "radius.8", overflow: "hidden", opacity: isOpen ? "opacity.full" : "opacity.none", visibility: isOpen ? "visible" : "hidden", transitionProperty: "opacity, transform, visibility", transitionDuration: "motionDuration.300", transform: isOpen ? undefined : "translateY(10%)", backgroundColor: "color.background.default", width: "sizing.536", maxWidth: "90vw", children: _jsx(Tabs, { items: tabsItems, defaultValue: currentTab, onChange: setCurrentTab }) }), _jsx(Button, { ref: triggerRef, icon: isOpen ? CloseIcon : GearFilledIcon, variant: "primary", onPress: () => {
                    setIsOpen(!isOpen);
                }, children: "Dev Tools" })] }));
};
